import api from '@/api/dashboard'

const state = {
  info: {
    weather: {
      timestamp: 0,
      data: []
    }
  },
  disasters: [],
  reports: []
}

const mutations = {
  setInfo(state, value) {
    state.info = value
  },
  setDisasters(state, value) {
    state.disasters = value
  },
  setReports(state, value) {
    state.reports = value
  },
  setWeathers (state, value) {
    state.info.weather = value
  }
}

const actions = {
  getInfo ({commit}) {
    return api.getInfo()
      .then(res => {
        commit('setInfo', res.data.data)
        return res
      })
  },
  getDisasters ({commit}) {
    return api.getDisasters()
      .then(res => {
        commit('setDisasters', res.data.data)
        return res
      })
  },
  getReports ({commit}) {
    return api.getReports()
      .then(res => {
        commit('setReports', res.data.data)
        return res
      })
  },
  fetchWeathers ({commit}) {
    return api.getWeathers()
      .then(res => {
        commit('setWeathers', res.data)
        return res
      })
  }
}

const getters = {
  info: state => state.info,
  disasters: state => state.disasters,
  reports: state => state.reports
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
